import React from 'react';
import cn from 'classnames';
import { analyticsInteraction } from 'utils/analytics';
import { i18n } from 'utils/i18n';
import { ANALYTICS } from 'constants';
import ExtraFlyoutTabDrawer from 'components/ReservationFlow/Extras/ExtraFlyoutTabDrawer';
import Button from 'components/Button';
import FlyoutTabDrawer from './FlyoutTabDrawer';
import { propTypes, defaultProps } from './FlyoutTabPropTypes';

const FlyoutTab = (props) => {
  const { isExpanded, icon, item, isSmall, fullWidth, uuid, contentKey, labelKey, isExtrasDrawer, onClick } = props;

  const { disabled } = item;
  const uuidButton = `${uuid}_button`;
  const uuidDrawer = `${uuid}_drawer`;
  const TabDrawer = isExtrasDrawer ? ExtraFlyoutTabDrawer : FlyoutTabDrawer;

  const handleClick = () => {
    // Analytics
    analyticsInteraction(ANALYTICS.DRAWER, item[labelKey], isExpanded ? ANALYTICS.CLOSE : ANALYTICS.OPEN);

    onClick();
  };

  return (
    <li className={cn('flyout-tabs__list-item', { 'has-disabled': disabled })}>
      {disabled && <span className='flyout-tabs__disabled-text'>{i18n('unavailable_at_this_location')}</span>}
      <div className={cn('flyout-tab', { disabled, expanded: !disabled && isExpanded })}>
        <Button
          plain
          className='flyout-tab__toggler'
          id={uuidButton}
          aria-label={item[labelKey]}
          aria-expanded={isExpanded.toString()}
          aria-controls={uuidDrawer}
          onClick={handleClick}
          role='tab'
          type='button'
        >
          <span className={`flyout-tab__title ${item.icon || icon || ''}`}>
            {item[labelKey]}
            {item.showCount ? ` (x${item.selected_quantity})` : ''}
          </span>
        </Button>

        {(isSmall || !fullWidth) && (
          <TabDrawer contentKey={contentKey} item={item} isExpanded={isExpanded} uuid={uuid} />
        )}
      </div>
    </li>
  );
};

FlyoutTab.propTypes = propTypes;
FlyoutTab.defaultProps = defaultProps;

export default FlyoutTab;
